/* eslint-disable no-unused-vars */
/* eslint-disable import/prefer-default-export */

import axios from 'axios';
import parser from 'html-react-parser';
import { withdrawAPI, withdrawBalanceAPI } from '../../api/ENDPOINTS/withdraw';
import { fetchData } from '../../api/GET/fetchData';
import { localLoginToken } from '../../authorization/login';
import { getRequest, postRequest, deleteRequest } from '../../utils/requests';
import {
    HANDLE_INPUT,
    LAST_APPROVED_WITHDRAW,
    LOADER,
    RESET_FORM_INPUT,
    RESET_RESPONSE_STATUS,
    SET_RESPONSE_STATUS,
    SHOW_ALERT,
    TINY_LOADER,
    WITHDRAW_BALANCE,
    WITHDRAW_LIST,
} from './Types';

export function getWithdrawBalance() {
    return async (dispatch) => {
        dispatch({
            type: TINY_LOADER,
            payload: true,
        });
        const queryStatus = '?status=approved';
        const response = await getRequest(withdrawBalanceAPI);
        const lastApproved = response.data.last_withdraw.length
            ? response.data.last_withdraw[0]
            : {};
        dispatch({
            type: WITHDRAW_BALANCE,
            payload: { balance: response.data, lastApproved },
        });
        dispatch({
            type: TINY_LOADER,
            payload: false,
        });
    };
}

export function getAllWithdraw(queryStatus = 'pending') {
    return async (dispatch) => {
        dispatch({
            type: LOADER,
            payload: true,
        });
        const response = await getRequest(`${withdrawAPI}/?status=${queryStatus}`);

        dispatch({
            type: WITHDRAW_LIST,
            payload: response.data,
        });
        dispatch({
            type: LOADER,
            payload: false,
        });
    };
}

export function handleWithdrawRequestInput(Input) {
    console.log('Input', Input);
    return async (dispatch) => {
        dispatch({
            type: HANDLE_INPUT,
            payload: Input,
        });
    };
}

export function createWithdraw(formData) {
    const status = {};
    return async (dispatch) => {
        dispatch({
            type: TINY_LOADER,
            payload: true,
        });

        const response = await postRequest(withdrawAPI, formData);
        if (response) {
            if (response.status === 200 || response.status === 201) {
                status.status = response.status;
                status.message = response.statusText;
            } else {
                status.status = response.response.data.data.status;
                status.message = parser(response.response.data.message);
            }
        }
        dispatch({ type: SET_RESPONSE_STATUS, payload: status });
        dispatch({
            type: TINY_LOADER,
            payload: false,
        });
        dispatch({
            type: SHOW_ALERT,
            payload: true,
        });
        dispatch(getAllWithdraw());
    };
}

export function cancelWithdraw(withdrawId) {
    return async (dispatch) => {
        dispatch({
            type: TINY_LOADER,
            payload: true,
        });
        await postRequest(`${withdrawAPI}/${withdrawId}`, {});

        dispatch(getAllWithdraw());
        dispatch({
            type: TINY_LOADER,
            payload: false,
        });
    };
}

export function resetWithdrawForm() {
    return async (dispatch, getState) => {
        const { resetWithdrawRequest } = getState().withdraw;
        dispatch({
            type: RESET_FORM_INPUT,
            payload: resetWithdrawRequest,
        });
    };
}

export function resetResponseStatus() {
    return async function dispatchResetResponse(dispatch) {
        dispatch({
            type: RESET_RESPONSE_STATUS,
            payload: {},
        });
    };
}
